export default function HomepageSEO() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': 'https://www.qiyoucinema.com/#webpage',
    'url': 'https://www.qiyoucinema.com/',
    'name': '奇优影院 - 不缓冲流畅播放 | 秒开无卡顿极速播放 | 高清电影电视剧免费在线',
    'description': '奇优影院提供不缓冲、流畅播放的观影体验，秒开无卡顿极速播放。高清电影电视剧全集免费在线观看，畅享顺畅视觉盛宴。',
    'isPartOf': {
      '@id': 'https://www.qiyoucinema.com/#website',
    },
    'primaryImageOfPage': {
      '@type': 'ImageObject',
      'url': 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20streaming%20platform%20with%20warm%20golden%20lighting%2C%20dark%20elegant%20background%2C%20professional%20film%20poster%20collage%20aesthetic&width=1920&height=900&seq=homepage-og-image&orientation=landscape',
    },
    'breadcrumb': {
      '@type': 'BreadcrumbList',
      'itemListElement': [
        {
          '@type': 'ListItem',
          'position': 1,
          'name': '首页',
          'item': 'https://www.qiyoucinema.com/',
        },
      ],
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}